import { createSelector } from '@reduxjs/toolkit';

import { GlobalState } from '@/redux/store';

const stateSelector = (state: GlobalState) => state;
const checkoutShippingQuoteSlice = createSelector(stateSelector, (state) => state.checkoutShippingQuote);

const idSelector = (_: GlobalState, id: number) => id;

export const getShippingQuoteError = createSelector(checkoutShippingQuoteSlice, (state) => state.quoteError);

export const getCheckoutShippingQuote = createSelector(checkoutShippingQuoteSlice, (state) => state.shippingQuote);

const loadedSelector = createSelector(checkoutShippingQuoteSlice, (state) => state.loaded);

const loadingSelector = createSelector(checkoutShippingQuoteSlice, (state) => state.loading);

export const getLoadTimeForCheckoutShippingQuote = createSelector(
    [loadedSelector, idSelector],
    (loaded, id) => loaded[id] || 0
);

export const isCheckoutShippingQuoteLoading = createSelector([loadingSelector, idSelector], (loading, id) =>
    loading.includes(id)
);

export const getIsCheckoutShippingQuoteLoaded = createSelector([loadedSelector, idSelector], (loaded, id) =>
    loaded.hasOwnProperty(id)
);
